(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("alert", [], factory);
	else if(typeof exports === 'object')
		exports["alert"] = factory();
	else
		root["alert"] = factory();
})(this, function() {
return 